import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 6h10","key":"svg-0"}],["path",{"d":"M12 6v13","key":"svg-1"}],["path",{"d":"M8 17l8 -3","key":"svg-2"}],["path",{"d":"M16 10l-8 3","key":"svg-3"}]]

const IconCurrencyTugrik = createReactComponent('outline', 'currency-tugrik', 'CurrencyTugrik', __iconNode);

export default IconCurrencyTugrik;